import React from 'react';
import { Container, Grid, Box, Typography, Hidden } from '@material-ui/core';
import { makeStyles, createStyles, useTheme } from '@material-ui/core/styles';
import PickOutline from "./Pick/PickOutline";
import LazyImage from "./App/LazyImage";
import {getContent} from "../actions/content";
import {connect} from 'react-redux';

const useStyles = makeStyles(theme => createStyles({
    group: {
        height: '100%'
    },
    progress: {
        position: 'absolute',
        padding: '4px'
    },
    spacer: {
        visibility: 'hidden'
    },
    section3Images: {
        '& img:first-child': {
            position: 'absolute'
        }
    },
    verticalSeparator: {
        backgroundColor: theme.palette.grey.darker,
        width: '1px',
        height: '80%',
        top: '10%'
    },
    videoGrid: {
        display: 'grid',
        maxWidth: '100%',
        width: '460px',
        margin: 'auto',
        [theme.breakpoints.up('md')]: {
            width: '100%',
            gridTemplateColumns: `calc(50% - ${theme.spacing(0)}px) calc(50% - ${theme.spacing(0)}px)`,
        }
    },
    videoGridHeading1: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        [theme.breakpoints.up('md')]: {
            gridRow: 1,
            gridColumn: 1,
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
        }
    },
    videoGridSubtitle1: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        [theme.breakpoints.up('md')]: {
            gridRow: 2,
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
            gridColumn: 1
        }
    },
    videoGridParagraph1: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        [theme.breakpoints.up('md')]: {
            gridRow: 3,
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
            gridColumn: 1
        }
    },
    videoGridVideo1: {
        marginBottom: theme.spacing(10),
        [theme.breakpoints.up('md')]: {
            gridRow: 4,
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
            gridColumn: 1,
            marginBottom: 0
        }
    },
    videoGridHeading2: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        [theme.breakpoints.up('md')]: {
            gridRow: 1,
            gridColumn: 2,
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
        }
    },
    videoGridSubtitle2: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        [theme.breakpoints.up('md')]: {
            gridRow: 2,
            gridColumn: 2,
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
            borderLeft: `solid 1px ${theme.palette.grey.darker}`
        }
    },
    videoGridParagraph2: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        [theme.breakpoints.up('md')]: {
            gridRow: 3,
            gridColumn: 2,
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
            borderLeft: `solid 1px ${theme.palette.grey.darker}`
        }
    },
    videoGridVideo2: {
        [theme.breakpoints.up('md')]: {
            gridRow: 4,
            gridColumn: 2,
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
            borderLeft: `solid 1px ${theme.palette.grey.darker}`
        }
    },
    section3: {
        position: 'relative',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    section3Heading: {
        textAlign: 'center',
        [theme.breakpoints.up('md')]: {
            textAlign: 'left'
        }
    },
    section3Image: {
        position: 'absolute',
        top: '60px',
        left: '20px',
        width: '90%',
        [theme.breakpoints.up('md')]: {
            left: 0
        }
    },
    section3BoxLeft: {
        [theme.breakpoints.down('sm')]: {
            border: 'none',
            borderLeft: `solid 3px ${theme.palette.secondary.main}`,
            padding: '0 10px',
            borderRadius: 0,
            marginBottom: theme.spacing(3),
            '& *': {
                textAlign: 'left',
            }
        },
        [theme.breakpoints.up('md')]: {
            height: '100%',
            padding: '10px 24% 10px 10px',
        }
    },
    section3BoxRight: {
        [theme.breakpoints.down('sm')]: {
            border: 'none',
            borderLeft: `solid 3px ${theme.palette.secondary.main}`,
            padding: '0 10px',
            borderRadius: 0,
            marginBottom: theme.spacing(3),
            '& *': {
                textAlign: 'left'
            }
        },
        [theme.breakpoints.up('md')]: {
            height: '100%',
            padding: '10px 10px 10px 24%',
        }
    },
    section3BoxFirst: {
        [theme.breakpoints.down('sm')]: {
            padding: '10px 40% 10px 10px'
        }
    },
    section3BoxSecond: {
        [theme.breakpoints.down('sm')]: {
            padding: '10px 40% 10px 10px'
        }
    },
    section3PickOutlineContainer: {
        width: '200%',
        height: '100%',
        position: 'absolute',
        top: 0,
        overflow: 'hidden',
        left: '-88%',
        [theme.breakpoints.up('md')]: {
            width: '100%',
            left: 0,
        }
    },
    section4PickOutlineContainer: {
        width: '70%',
        height: '70%',
        position: 'absolute',
        top: '50%',
        left: 0,
        transform: 'translate(-50%, -50%)',
        '& > div': {
            position: 'absolute'
        },
        '& > div:nth-child(1)': {
            transform: 'rotateY(180deg) rotateZ(6deg)',
        },
        '& > div:nth-child(2)': {
            transform: 'rotateY(180deg) rotateZ(10deg)',
        }
    }
}));

const ApiOpportunityPage = ({getContent, content = {}}) => {
    const classes = useStyles();
    const theme = useTheme();

    const get = (property) => {
        return (content && content[property]) ? content[property] : '';
    };

    React.useEffect(() => {
        getContent('API');
    }, [getContent]);

    return (
        <>
            <Box bgcolor="white.main" mt={6} pt={6} pb={4}>
                <Container>
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography align="center" gutterBottom variant="h2" color="secondary">{get('Section_2_-_Heading')}</Typography>
                            <Typography align="center" component="center" dangerouslySetInnerHTML={{__html: get('Section_2_-_Content')}} />
                        </Grid>
                    </Grid>
                </Container>
            </Box>
            <Box bgcolor="white.main" mt={6} position="relative" zIndex={2}>
                <div className={classes.section3PickOutlineContainer}><PickOutline colors={[theme.palette.primary.main, '#D8E0E4']} /></div>
                <Box position="relative" pt={6} pb={4}>
                    <Container>
                        <Box pb={4} pt={10}>
                            <Grid container spacing={6}>
                                <Grid item xs={4} md={6} style={{position: 'relative'}}>
                                    <Hidden implementation="css" smDown>
                                        <LazyImage className={classes.section3Image} src={content[`Section_3_-_Image_-_URL`]} />
                                    </Hidden>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Typography className={classes.section3Heading} color="secondary" gutterBottom variant="h2">{get('Section_3_-_Heading')}</Typography>
                                    <Typography component="div" dangerouslySetInnerHTML={{__html: content['Section_3_-_Content']}} />
                                </Grid>
                            </Grid>
                        </Box>
                    </Container>
                </Box>
            </Box>
            <Box bgcolor="primary.main" mt={0} pt={6} pb={4} position="relative" zIndex={1} overflow="hidden">
                <div className={classes.section4PickOutlineContainer}>
                    <PickOutline colors={['#6857A9', '#6857A9']} />
                    <PickOutline colors={['#6857A9', '#6857A9']} />
                </div>
                <Container>
                    <Box pb={4}>
                        <Grid container spacing={6}>
                            <Grid item xs={4} sm={6} style={{position: 'relative'}}>
                                <Hidden implementation="css" mdUp>
                                    <LazyImage width="515px" height="893px" className={classes.section3Image} src={content[`Section_3_-_Image_-_URL`]} />
                                </Hidden>
                            </Grid>
                            <Grid item xs={8} sm={6}>
                                <Box color="white.main" mb={6}>
                                    <Typography variant="h5" color="white.main">{content[`Section_3_-_Row_1_-_Column_1_-_Heading`]}</Typography>
                                    {[1, 2, 3, 4].filter(i => content[`Section_3_-_Row_1_-_Column_1_-_List_Item_${i}`]).map(i => (
                                        <Typography gutterBottom key={i}>{content[`Section_3_-_Row_1_-_Column_1_-_List_Item_${i}`]}</Typography>
                                    ))}
                                </Box>
                                <Box color="white.main" mb={6}>
                                    <Typography variant="h5" color="white.main">{content[`Section_3_-_Row_1_-_Column_2_-_Heading`]}</Typography>
                                    {[1, 2, 3, 4].filter(i => content[`Section_3_-_Row_1_-_Column_2_-_List_Item_${i}`]).map(i => (
                                        <Typography gutterBottom key={i}>{content[`Section_3_-_Row_1_-_Column_2_-_List_Item_${i}`]}</Typography>
                                    ))}
                                </Box>
                                <Box color="white.main" mb={6}>
                                    <Typography variant="h5" color="white.main">{content[`Section_3_-_Row_2_-_Column_1_-_Heading`]}</Typography>
                                    {[1, 2, 3, 4].filter(i => content[`Section_3_-_Row_2_-_Column_1_-_List_Item_${i}`]).map(i => (
                                        <Typography gutterBottom key={i}>{content[`Section_3_-_Row_2_-_Column_1_-_List_Item_${i}`]}</Typography>
                                    ))}
                                </Box>
                                <Box color="white.main" mb={6}>
                                    <Typography variant="h5" color="white.main">{content[`Section_3_-_Row_2_-_Column_2_-_Heading`]}</Typography>
                                    {[1, 2, 3, 4].filter(i => content[`Section_3_-_Row_2_-_Column_2_-_List_Item_${i}`]).map(i => (
                                        <Typography gutterBottom key={i}>{content[`Section_3_-_Row_2_-_Column_2_-_List_Item_${i}`]}</Typography>
                                    ))}
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>
            </Box>
        </>
    );
};


export default connect(
    (state) => ({
        content: state.content.content,
    }),
    { getContent }
)(ApiOpportunityPage);